// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Shared overlay ─────────────────────────── */
.notify_overlay__N-I-\\+ {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(10, 8, 6, 0.72);
}

/* Full-screen flashing layer (receiver side). Colour is set inline; this
   only animates the opacity so the chosen colour pulses behind the card. */
.notify_flashLayer__zsnk9 {
  position: absolute;
  inset: 0;
  pointer-events: none;
  animation: notify_notifyFlash__VHgwy 0.9s ease-in-out infinite;
}

@keyframes notify_notifyFlash__VHgwy {
  0%, 100% { opacity: 0.12; }
  50%      { opacity: 0.62; }
}

.notify_notifySendModal__0QkNW {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 70vw;
  background: #1a1815;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-14);
  padding: 50px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
  overflow: scroll;
  max-height: 70vh;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.notify_title__az9bo {
  font-size: var(--fs-16);
  font-weight: var(--fw-bold);
  color: #f0ebe4;
  margin-bottom: 4px;
}

.notify_subtitle__ZjyOZ {
  font-size: var(--fs-11);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #8a7f74;
  margin-bottom: 18px;
}

.notify_error__qrTp8 {
  background: rgba(160, 30, 30, 0.13);
  border: 1px solid rgba(224, 48, 48, 0.4);
  color: #ff9999;
  border-radius: var(--radius-8);
  padding: 8px 11px;
  font-size: var(--fs-12);
  margin-bottom: 14px;
}

/* ── Send form ──────────────────────────────── */
.notify_label__kn6Bd {
  display: block;
  font-size: var(--fs-11);
  letter-spacing: 0.5px;
  color: #b0a394;
  margin-bottom: 6px;
}

.notify_textarea__0R46u {
  width: 100%;
  min-height: 84px;
  resize: vertical;
  background: #14120f;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-8);
  padding: 10px 12px;
  color: #f0ebe4;
  font-size: var(--fs-13);
  font-family: inherit;
  margin-bottom: 18px;
  box-sizing: border-box;
}
.notify_textarea__0R46u:focus { outline: none; border-color: var(--accent); }

.notify_swatchRow__zh9Sv {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.notify_swatch__jJKiS {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  transition: transform 0.1s ease;
}
.notify_swatch__jJKiS:hover { transform: scale(1.1); }
.notify_swatchActive__QCeCQ { border-color: #f0ebe4; box-shadow: 0 0 0 2px #1a1815, 0 0 0 4px currentColor; }

.notify_colorInput__WXbzX {
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px dashed var(--text-dim);
  border-radius: 50%;
  background: none;
  cursor: pointer;
}

/* "No colour" option — sends an empty colour so the receiver modal doesn't flash. */
.notify_swatchNone__2suRZ {
  background: transparent;
  border: 2px dashed var(--text-dim);
}

/* ── Actions ────────────────────────────────── */
.notify_actions__z1Vx1 {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.notify_actionsReceiver__W7sWy { justify-content: center; flex-wrap: wrap; }

.notify_btn__ITY4G {
  border: none;
  border-radius: var(--radius-8);
padding: 15px 20px;
    font-size: var(--fs-20);
  font-weight: var(--fw-semibold);
  font-family: inherit;
  cursor: pointer;
}
.notify_btn__ITY4G:disabled { opacity: 0.5; cursor: default; }

.notify_btnPrimary__LoNaF { background: var(--accent); color: #1a1815; }
.notify_btnCancel__Wt6Z-  { background: var(--border); color: #b0a394; }
.notify_btnIgnore__HlrNx  { background: var(--border); color: #b0a394; }
.notify_btnGotIt__d9qmj   { background: #4a8a6a; color: #f0f5f2; }
.notify_btnClose__Bj53X   { background: var(--border-strong); color: #d4c8ba; }

/* ── Receiver message ───────────────────────── */
.notify_message__Thl74 {
  font-size: var(--fs-32);
  line-height: 1.5;
  color: #f5f0eb;
  white-space: pre-wrap;
  margin: 6px 0 22px;
  text-align: center;
}
.notify_header__-euxO {
  font-size: var(--fs-30);
  text-align: center;
  margin-bottom: 8px;
}

/* ── Light mode ─────────────────────────────────
   The \`light\` class is added to the .overlay; descendants are overridden
   here so the send form and received-message modal read on a light theme. */
.notify_overlay__N-I-\\+.notify_light__7N52H {
  background: rgba(228, 220, 210, 0.6);
}

.notify_light__7N52H .notify_notifySendModal__0QkNW {
  background: #faf7f4;
  border-color: #e2d9cd;
  box-shadow: 0 24px 60px rgba(60, 50, 40, 0.22);
}

.notify_light__7N52H .notify_title__az9bo    { color: #2a2520; }
.notify_light__7N52H .notify_subtitle__ZjyOZ { color: #9a8a7a; }
.notify_light__7N52H .notify_label__kn6Bd    { color: #6a5c4e; }

.notify_light__7N52H .notify_textarea__0R46u {
  background: var(--surface-light);
  border-color: #d8d0c4;
  color: #2a2520;
}
.notify_light__7N52H .notify_textarea__0R46u:focus { border-color: var(--accent); }

.notify_light__7N52H .notify_swatchActive__QCeCQ {
  border-color: #2a2520;
  box-shadow: 0 0 0 2px #faf7f4, 0 0 0 4px currentColor;
}
.notify_light__7N52H .notify_colorInput__WXbzX { border-color: #b8a898; }
.notify_light__7N52H .notify_swatchNone__2suRZ { border-color: #b8a898; }

.notify_light__7N52H .notify_error__qrTp8 {
  background: rgba(190, 40, 40, 0.08);
  border-color: rgba(200, 50, 50, 0.4);
  color: #b13030;
}

.notify_light__7N52H .notify_btnCancel__Wt6Z- { background: #e8e0d4; color: #6a5c4e; }
.notify_light__7N52H .notify_btnClose__Bj53X  { background: #e2d9cd; color: var(--text-faint); }
.notify_light__7N52H .notify_btnIgnore__HlrNx { background: #e8e0d4; color: #6a5c4e; }

/* Received-message modal (NotifyListener) — dark text reads against the
   lighter scrim and the pulsing flash colour. */
.notify_light__7N52H .notify_message__Thl74 { color: #2a2520; }
.notify_light__7N52H .notify_header__-euxO  { color: #2a2520; }
`, "",{"version":3,"sources":["webpack://./src/styles/notify.module.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;2EAC2E;AAC3E;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,8DAAgD;AAClD;;AAEA;EACE,WAAW,aAAa,EAAE;EAC1B,WAAW,aAAa,EAAE;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;AACA,gCAAkB,aAAa,EAAE,2BAA2B,EAAE;;AAE9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,+BAA+B;AACjC;AACA,8BAAgB,qBAAqB,EAAE;AACvC,8BAAgB,qBAAqB,EAAE,qDAAqD,EAAE;;AAE9F;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oFAAoF;AACpF;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;AACA,iCAAmB,uBAAuB,EAAE,eAAe,EAAE;;AAE7D;EACE,YAAY;EACZ,8BAA8B;AAChC,kBAAkB;IACd,uBAAuB;EACzB,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;AACjB;AACA,8BAAgB,YAAY,EAAE,eAAe,EAAE;;AAE/C,4BAAc,yBAAyB,EAAE,cAAc,EAAE;AACzD,4BAAc,yBAAyB,EAAE,cAAc,EAAE;AACzD,4BAAc,yBAAyB,EAAE,cAAc,EAAE;AACzD,4BAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,4BAAc,gCAAgC,EAAE,cAAc,EAAE;;AAEhE,kDAAkD;AAClD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;4EAE4E;AAC5E;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,+CAAmB,cAAc,EAAE;AACnC,+CAAmB,cAAc,EAAE;AACnC,+CAAmB,cAAc,EAAE;;AAEnC;EACE,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;AAChB;AACA,qDAAyB,2BAA2B,EAAE;;AAEtD;EACE,qBAAqB;EACrB,qDAAqD;AACvD;AACA,iDAAqB,qBAAqB,EAAE;AAC5C,iDAAqB,qBAAqB,EAAE;;AAE5C;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA,gDAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,gDAAoB,mBAAmB,EAAE,wBAAwB,EAAE;AACnE,gDAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;gDACgD;AAChD,8CAAkB,cAAc,EAAE;AAClC,8CAAkB,cAAc,EAAE","sourcesContent":["/* ── Shared overlay ─────────────────────────── */\n.overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(10, 8, 6, 0.72);\n}\n\n/* Full-screen flashing layer (receiver side). Colour is set inline; this\n   only animates the opacity so the chosen colour pulses behind the card. */\n.flashLayer {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  animation: notifyFlash 0.9s ease-in-out infinite;\n}\n\n@keyframes notifyFlash {\n  0%, 100% { opacity: 0.12; }\n  50%      { opacity: 0.62; }\n}\n\n.notifySendModal {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 70vw;\n  background: #1a1815;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-14);\n  padding: 50px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);\n  overflow: scroll;\n  max-height: 70vh;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.title {\n  font-size: var(--fs-16);\n  font-weight: var(--fw-bold);\n  color: #f0ebe4;\n  margin-bottom: 4px;\n}\n\n.subtitle {\n  font-size: var(--fs-11);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: #8a7f74;\n  margin-bottom: 18px;\n}\n\n.error {\n  background: rgba(160, 30, 30, 0.13);\n  border: 1px solid rgba(224, 48, 48, 0.4);\n  color: #ff9999;\n  border-radius: var(--radius-8);\n  padding: 8px 11px;\n  font-size: var(--fs-12);\n  margin-bottom: 14px;\n}\n\n/* ── Send form ──────────────────────────────── */\n.label {\n  display: block;\n  font-size: var(--fs-11);\n  letter-spacing: 0.5px;\n  color: #b0a394;\n  margin-bottom: 6px;\n}\n\n.textarea {\n  width: 100%;\n  min-height: 84px;\n  resize: vertical;\n  background: #14120f;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-8);\n  padding: 10px 12px;\n  color: #f0ebe4;\n  font-size: var(--fs-13);\n  font-family: inherit;\n  margin-bottom: 18px;\n  box-sizing: border-box;\n}\n.textarea:focus { outline: none; border-color: var(--accent); }\n\n.swatchRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.swatch {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n  padding: 0;\n  transition: transform 0.1s ease;\n}\n.swatch:hover { transform: scale(1.1); }\n.swatchActive { border-color: #f0ebe4; box-shadow: 0 0 0 2px #1a1815, 0 0 0 4px currentColor; }\n\n.colorInput {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 1px dashed var(--text-dim);\n  border-radius: 50%;\n  background: none;\n  cursor: pointer;\n}\n\n/* \"No colour\" option — sends an empty colour so the receiver modal doesn't flash. */\n.swatchNone {\n  background: transparent;\n  border: 2px dashed var(--text-dim);\n}\n\n/* ── Actions ────────────────────────────────── */\n.actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n.actionsReceiver { justify-content: center; flex-wrap: wrap; }\n\n.btn {\n  border: none;\n  border-radius: var(--radius-8);\npadding: 15px 20px;\n    font-size: var(--fs-20);\n  font-weight: var(--fw-semibold);\n  font-family: inherit;\n  cursor: pointer;\n}\n.btn:disabled { opacity: 0.5; cursor: default; }\n\n.btnPrimary { background: var(--accent); color: #1a1815; }\n.btnCancel  { background: var(--border); color: #b0a394; }\n.btnIgnore  { background: var(--border); color: #b0a394; }\n.btnGotIt   { background: #4a8a6a; color: #f0f5f2; }\n.btnClose   { background: var(--border-strong); color: #d4c8ba; }\n\n/* ── Receiver message ───────────────────────── */\n.message {\n  font-size: var(--fs-32);\n  line-height: 1.5;\n  color: #f5f0eb;\n  white-space: pre-wrap;\n  margin: 6px 0 22px;\n  text-align: center;\n}\n.header {\n  font-size: var(--fs-30);\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n/* ── Light mode ─────────────────────────────────\n   The `light` class is added to the .overlay; descendants are overridden\n   here so the send form and received-message modal read on a light theme. */\n.overlay.light {\n  background: rgba(228, 220, 210, 0.6);\n}\n\n.light .notifySendModal {\n  background: #faf7f4;\n  border-color: #e2d9cd;\n  box-shadow: 0 24px 60px rgba(60, 50, 40, 0.22);\n}\n\n.light .title    { color: #2a2520; }\n.light .subtitle { color: #9a8a7a; }\n.light .label    { color: #6a5c4e; }\n\n.light .textarea {\n  background: var(--surface-light);\n  border-color: #d8d0c4;\n  color: #2a2520;\n}\n.light .textarea:focus { border-color: var(--accent); }\n\n.light .swatchActive {\n  border-color: #2a2520;\n  box-shadow: 0 0 0 2px #faf7f4, 0 0 0 4px currentColor;\n}\n.light .colorInput { border-color: #b8a898; }\n.light .swatchNone { border-color: #b8a898; }\n\n.light .error {\n  background: rgba(190, 40, 40, 0.08);\n  border-color: rgba(200, 50, 50, 0.4);\n  color: #b13030;\n}\n\n.light .btnCancel { background: #e8e0d4; color: #6a5c4e; }\n.light .btnClose  { background: #e2d9cd; color: var(--text-faint); }\n.light .btnIgnore { background: #e8e0d4; color: #6a5c4e; }\n\n/* Received-message modal (NotifyListener) — dark text reads against the\n   lighter scrim and the pulsing flash colour. */\n.light .message { color: #2a2520; }\n.light .header  { color: #2a2520; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `notify_overlay__N-I-+`,
	"flashLayer": `notify_flashLayer__zsnk9`,
	"notifyFlash": `notify_notifyFlash__VHgwy`,
	"notifySendModal": `notify_notifySendModal__0QkNW`,
	"title": `notify_title__az9bo`,
	"subtitle": `notify_subtitle__ZjyOZ`,
	"error": `notify_error__qrTp8`,
	"label": `notify_label__kn6Bd`,
	"textarea": `notify_textarea__0R46u`,
	"swatchRow": `notify_swatchRow__zh9Sv`,
	"swatch": `notify_swatch__jJKiS`,
	"swatchActive": `notify_swatchActive__QCeCQ`,
	"colorInput": `notify_colorInput__WXbzX`,
	"swatchNone": `notify_swatchNone__2suRZ`,
	"actions": `notify_actions__z1Vx1`,
	"actionsReceiver": `notify_actionsReceiver__W7sWy`,
	"btn": `notify_btn__ITY4G`,
	"btnPrimary": `notify_btnPrimary__LoNaF`,
	"btnCancel": `notify_btnCancel__Wt6Z-`,
	"btnIgnore": `notify_btnIgnore__HlrNx`,
	"btnGotIt": `notify_btnGotIt__d9qmj`,
	"btnClose": `notify_btnClose__Bj53X`,
	"message": `notify_message__Thl74`,
	"header": `notify_header__-euxO`,
	"light": `notify_light__7N52H`
};
export default ___CSS_LOADER_EXPORT___;
